<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #list>
        <NoneChevronExpansionPanel>
          <template #header>
            <div class="headerAreaStyle d-flex align-center px-9">
              <div class="headerTitleStyle">
                {{ $t('nextengine.nextengine_cooperate-config') }}
              </div>
            </div>
          </template>
          <template #content>
            <div class="contentAreaStyle">
              <v-row class="px-9 pt-4">
                <v-col cols="12" class="pb-0">
                  <h4 class="sub-heading-text">
                    {{
                      $t(
                        'nextengine.nextengine_cooperate-config-batch-time-title'
                      )
                    }}
                  </h4>
                  <p class="sub-item-text indent-content mb-2">
                    {{
                      $t(
                        'nextengine.nextengine_cooperate-config-batch-time-detail'
                      )
                    }}
                  </p>
                </v-col>
              </v-row>
              <v-row align="center" class="px-9 form-row">
                <v-col cols="auto" class="pl-9 py-1">
                  <span>{{
                    $t('nextengine.nextengine_cooperate-config-batch-time1')
                  }}</span>
                </v-col>
                <v-col cols="5" sm="3" md="2" class="py-1">
                  <v-select
                    v-model="batchExecuteTime1"
                    :items="hourListNotNull"
                    item-text="text"
                    item-value="value"
                    height="32px"
                    dense
                    return-object
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
              <v-row align="center" class="px-9 form-row">
                <v-col cols="auto" class="pl-9 py-1">
                  <span>{{
                    $t('nextengine.nextengine_cooperate-config-batch-time2')
                  }}</span>
                </v-col>
                <v-col cols="5" sm="3" md="2" class="py-1">
                  <v-select
                    v-model="batchExecuteTime2"
                    :items="hourList"
                    item-text="text"
                    item-value="value"
                    height="32px"
                    dense
                    return-object
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
              <v-row align="center" class="px-9 form-row">
                <v-col cols="auto" class="pl-9 py-1">
                  <span>{{
                    $t('nextengine.nextengine_cooperate-config-batch-time3')
                  }}</span>
                </v-col>
                <v-col cols="5" sm="3" md="2" class="py-1">
                  <v-select
                    v-model="batchExecuteTime3"
                    :items="hourList"
                    item-text="text"
                    item-value="value"
                    height="32px"
                    dense
                    return-object
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
              <!-- ネクストエンジン連係の主体選択機能はコメントアウト
              <v-row class="px-9 pt-6">
                <v-col cols="12" class="pb-0">
                  <h4 class="sub-heading-text">
                    {{
                      $t(
                        'nextengine.nextengine_cooperate-config-control-type-title'
                      )
                    }}
                  </h4>
                </v-col>
              </v-row>
              <v-row align="center" class="px-9">
                <v-radio-group
                  v-model="controlType"
                  class="pl-9 radio-group-compact"
                >
                  <v-radio
                    :label="
                      $t(
                        'nextengine.nextengine_cooperate-config-control-type-nextengine'
                      )
                    "
                    :value="1"
                    class="pl-2"
                  ></v-radio>
                  <v-radio
                    :label="
                      $t(
                        'nextengine.nextengine_cooperate-config-control-type-spes'
                      )
                    "
                    :value="2"
                    class="pl-2"
                  ></v-radio>
                </v-radio-group>
              </v-row>
              -->
            </div>
            <div class="footerAreaStyle d-flex justify-end align-center px-9">
              <NormalButton
                :text="$t('common.input_save')"
                height="50px"
                width="130px"
                @click="updateNeCooperateConfig()"
              />
            </div>
          </template>
        </NoneChevronExpansionPanel>
      </template>
    </Master>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { Master } from '@/components/layouts'
import { NoneChevronExpansionPanel } from '@/components/items'
import { NormalButton } from '@/components/items'
import { format } from 'date-fns'
import { subMonths } from 'date-fns'

export default {
  components: {
    Master,
    NoneChevronExpansionPanel,
    NormalButton
  },
  data: () => {
    return {
      pageTitle: 'nextengine.nextengine_cooperate-config',
      batchExecuteTime1: null,
      batchExecuteTime2: null,
      batchExecuteTime3: null,
      controlType: null,
      hourListNotNull: [],
      hourList: []
    }
  },
  created() {
    this.fetchNeConfig()
    this.getHourList()
  },
  methods: {
    ...mapActions('Nextengine', [
      'getNextengineCooperateConfigFromApi',
      'updateNextengineCooperateConfigFromApi'
    ]),
    ...mapGetters('Nextengine', ['getNextengineCooperateConfigFromState']),
    async fetchNeConfig() {
      const neConfig = await this.getNextengineCooperateConfigFromApi()
      const apiData = neConfig.data // APIから返ってきたデータ
      this.controlType = neConfig.data.controlType
      // APIから取得した数値 (value) に基づいて、hourListから対応するオブジェクトを探して設定する
      this.batchExecuteTime1 =
        this.hourList.find(
          (item) => item.value === apiData.batchExecuteTime1
        ) || 0

      this.batchExecuteTime2 =
        this.hourList.find(
          (item) => item.value === apiData.batchExecuteTime2
        ) || null

      this.batchExecuteTime3 =
        this.hourList.find(
          (item) => item.value === apiData.batchExecuteTime3
        ) || null
    },
    getHourList() {
      // ②②用のリストだけ先頭にnull選択肢追加
      this.hourList.push({
        value: null,
        text: ''
      })
      // 00:00～23:00のリストを作成する
      for (let getHourCount = 0; getHourCount < 24; getHourCount++) {
        const formatData = {
          value: getHourCount,
          text: this.zeroPad(getHourCount) + ':00'
        }
        this.hourList.push(formatData)
        this.hourListNotNull.push(formatData)
      }
    },
    zeroPad(num) {
      return String(num).padStart(2, '0')
    },
    async updateNeCooperateConfig() {
      const formatData = {
        batchExecuteTime1: this.batchExecuteTime1
          ? this.batchExecuteTime1.value
          : 0,
        batchExecuteTime2: this.batchExecuteTime2
          ? this.batchExecuteTime2.value
          : null,
        batchExecuteTime3: this.batchExecuteTime3
          ? this.batchExecuteTime3.value
          : null,
        // controlType: this.controlType
        controlType: 1 // ネクストエンジン側主体で固定
      }
      const success = await this.updateNextengineCooperateConfigFromApi(
        formatData
      )

      if (success) {
        alert(this.$t('nextengine.nextengine_cooperate-config-update-success'))
        this.$router.go({ path: this.$router.currentRoute.path, force: true })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.headerTitleStyle {
  font-size: 18px;
  font-weight: bold;
}
.headerAreaStyle {
  height: 70px;
}
.contentAreaStyle {
  font-size: 14px;
  padding-bottom: 20px; /* ボタンとの重なりを避けるため下の余白を追加 */
}

.sub-heading-text {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px; /* 見出し下のマージンを小さく */
  color: #333;
}

.indent-content {
  padding-left: 25px !important;
}

/* フォームの行の間隔を詰めるためのクラス */
.form-row {
  margin-bottom: 4px;
}

/* v-radio-group内の間隔を詰める */
.radio-group-compact {
  ::v-deep .v-input--radio-group__input {
    > .v-radio:not(:last-child) {
      margin-bottom: 10px !important;
    }
  }
}

.footerAreaStyle {
  height: 70px;
  padding: 0 9px;
}

::v-deep .v-input__append-inner {
  margin-top: 4px !important;
}
</style>
